import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { Priviledge } from './types'

export const fetchPriviledgesList = async (params?: { abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url('/admin/1.0/priviledges')
    .signal(params?.abortCtrl)
    .get()
    .json<ListingResponse<Priviledge>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
